import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SpFormControlsModule } from '@components/sp-form-controls';

@Component({
    selector: 'web-widget-extended-hide-settings',
    templateUrl: './web-widget-extended-hide-settings.component.html',
    styleUrls: ['./web-widget-extended-hide-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SpFormControlsModule, TranslateModule, TooltipModule],
})
export class WebWidgetExtendedHideSettingsComponent {
    @Input() public hideOnMobile: boolean;
    @Input() public hideOnTablet: boolean;
    @Input() public hideOnDesktop: boolean;

    @Output() public hideOnMobileChange: EventEmitter<boolean> = new EventEmitter();
    @Output() public hideOnTabletChange: EventEmitter<boolean> = new EventEmitter();
    @Output() public hideOnDesktopChange: EventEmitter<boolean> = new EventEmitter();

    public onHideOnMobileChange(value: boolean): void {
        this.hideOnMobileChange.emit(value);
    }

    public onHideOnTabletChange(value: boolean): void {
        this.hideOnTabletChange.emit(value);
    }

    public onHideOnDesktopChange(value: boolean): void {
        this.hideOnDesktopChange.emit(value);
    }
}
